let constants = {
    Roles: {
        CustomerAdminRole: 'General Admin',
        FleetUserRole: 'Fleet User',
        SystemRole: 'System Admin',
        CSRRole: 'TruckDown CSR'
    },
    Claims: {
        Name: 'name',
        Roles: 'role',
        ApiKey: 'apikey',
        LocalLogin: 'll',
        RealUser: 'run',
        ThirdPartyLogin: 'tpl',
        RequiresLocalLogin: 'rll'
    },
    Events: {
        NotificationReceived: "notification_received",
        NotificationDismissed: "notification_dismissed",
        NotificationClicked: "notification_clicked",
        NotificationPermissionChanged: "notification_permission_changed",
        NotificationsInitialized: "notification_initialized",
        ReceivedEvent: "received_event",
        RefreshOnboardingProgress: "refresh_onboarding_progress",
        OpenMenu: "open-menu",
        RefreshRequestsLink: "refresh-requests-link"
    },
    Settings: {
        ExternalId: "external_id",
        ServiceRequestMenuView: "service-request-menu-view"
    }
};
export const Constants = constants;